/* ============================================================
   MoxLand — divisor de títulos PT / EN (rede de segurança JS)
   Divide "Nome PT / Name EN" em título + subtítulo em QUALQUER
   lugar do site, inclusive conteúdo redesenhado por JavaScript
   (filtros, troca de idioma, "carregar mais", vitrines dinâmicas)
   e o título grande da página do produto.
   Regra igual à do snippet Liquid: divide ao meio; número ímpar
   de partes fica intacto.
   ============================================================ */
(function () {
  'use strict';

  /* injeta o estilo direto na página — não depende do CSS do tema */
  var css = ''
    + '.card-title__pt{display:block;}'
    + '.card-title__en{display:block;font-size:.72em;font-weight:400;'
    + 'font-style:italic;opacity:.62;letter-spacing:.01em;margin-top:.15em;'
    + 'line-height:1.25;}'
    + '.card-information .card-title__en,.card-title .card-title__en{'
    + 'font-size:.8em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'
    /* descortinador: títulos divididos nunca são cortados para 1 linha
       (o tema limita linhas no mobile; aqui liberamos SÓ onde dividimos) */
    + '.mx-split,.mx-split-pai{-webkit-line-clamp:unset!important;'
    + 'max-height:none!important;overflow:visible!important;'
    + 'display:block!important;}';
  var estilo = document.createElement('style');
  estilo.id = 'moxland-card-title-css';
  estilo.textContent = css;
  (document.head || document.documentElement).appendChild(estilo);

  var SELETORES = [
    '.card-title .text',           /* cards de vitrine (halo-product-card) */
    '.productView-title',          /* página do produto (família Halo/Ella) */
    '.productView-title span',
    'h1.productView-title',
    '.product-title',
    '.product__title',
    'h1.product-single__title',
    '.quickview-product .productView-title',
    '.quickview-product .product-title',
    '.halo-productList .card-title .text'
  ].join(', ');

  function dividir(el) {
    if (!el || el.querySelector('.card-title__pt')) return;   /* já dividido */
    if (el.dataset && el.dataset.mxSplit) return;

    /* pega só o texto direto do elemento (preserva filhos, ex.: variante) */
    var no = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { no = n; break; }
    }
    if (!no) return;

    var partes = no.textContent.trim().split(' / ');
    if (partes.length < 2 || partes.length % 2 !== 0) return; /* ímpar: intacto */
    for (var p = 0; p < partes.length; p++) {
      if (!partes[p].trim()) return;                          /* parte vazia: intacto */
    }

    var metade = partes.length / 2;
    var pt = partes.slice(0, metade).join(' / ');
    var en = partes.slice(metade).join(' / ');

    /* Site em português: PT grande + EN como subtítulo.
       Site em outro idioma: mostra APENAS o nome oficial em inglês
       (a metade "PT" pode ter sido adulterada pelo tradutor automático
       da loja, então não é confiável para exibir como subtítulo). */
    var idioma = (document.documentElement.lang || 'pt').toLowerCase();

    var spanPt = document.createElement('span');
    spanPt.className = 'card-title__pt';

    if (idioma.indexOf('pt') === 0) {
      spanPt.textContent = pt;
      var spanEn = document.createElement('span');
      spanEn.className = 'card-title__en';
      spanEn.textContent = en;
      el.insertBefore(spanPt, no);
      el.insertBefore(spanEn, no);
    } else {
      spanPt.textContent = en;   /* só o nome oficial, limpo */
      el.insertBefore(spanPt, no);
    }
    el.removeChild(no);
    if (el.dataset) el.dataset.mxSplit = '1';
    if (el.classList) el.classList.add('mx-split');
    var pai = el.closest ? el.closest('.card-title') : null;
    if (pai && pai.classList) pai.classList.add('mx-split-pai');
  }

  /* esconde a nota antiga de fonte do texto nas descrições já gravadas
     ("Texto em português conforme a impressão mais recente (...)") */
  function esconderNotas(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    var ems = raiz.querySelectorAll('em');
    for (var i = 0; i < ems.length; i++) {
      var t = (ems[i].textContent || '').trim();
      if (t.indexOf('Texto em portugu\u00eas conforme a impress\u00e3o mais recente') === 0) {
        var p = ems[i].closest ? ems[i].closest('p') : ems[i].parentElement;
        (p || ems[i]).style.display = 'none';
      }
    }
  }

  function varrer(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    var els = raiz.querySelectorAll(SELETORES);
    for (var i = 0; i < els.length; i++) dividir(els[i]);
    if (raiz.matches && raiz.matches(SELETORES)) dividir(raiz);
    esconderNotas(raiz);
  }

  function iniciar() {
    varrer(document);
    /* vigia: qualquer conteúdo novo injetado na página é dividido na hora */
    new MutationObserver(function (mutacoes) {
      for (var m = 0; m < mutacoes.length; m++) {
        var adicionados = mutacoes[m].addedNodes;
        for (var a = 0; a < adicionados.length; a++) {
          if (adicionados[a].nodeType === 1) varrer(adicionados[a]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
